require("../../vendor/slick.min");
// import Swiper from 'swiper';
// import 'swiper/css';
// import 'swiper/swiper-bundle.css';
// import 'swiper/css/effect-fade';
// import 'swiper/css/effect-fade';
// import 'swiper/css/autoplay';
// import 'swiper/components/effect-fade/effect-fade';

// const galleries = document.querySelectorAll('.slider-images-container');
//
// galleries.forEach((galleryItem, index) => {
//
//     galleryItem.classList.add(`photo-gallery-${index}`);
//
//     let galleryContainer = $(galleryItem).find('.fade-slider');
//     galleryContainer.addClass(`fade-slider-${index}`);
//
//
// });

$('.fade-slider').slick({
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
});

// const swiper = new Swiper('.fade-slider', {
//     // fadeEffect: { crossFade: true },
//     // virtualTranslate: true,
//     // autoplay: {
//     //     delay: 2500,
//     // disableOnInteraction: true,
//     // },
//     // speed: 1000,
//     slidersPerView: 1,
//     loop: true,
//     effect: "fade"
// });


